import { render, staticRenderFns } from "./RecordExtraLiftForm.vue?vue&type=template&id=5c980597&"
import script from "./RecordExtraLiftForm.vue?vue&type=script&lang=js&"
export * from "./RecordExtraLiftForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports